var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmnicanalidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.35 93.73",
    style: {
      enableBackground: "new 0 0 100.35 93.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#A3195B;}\n\t.st4{fill:#0F6285;}\n\t.st5{fill:#E94B3D;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:url(#SVGID_10_);}\n\t.st13{fill:url(#SVGID_11_);}\n\t.st14{fill:url(#SVGID_12_);}\n\t.st15{fill:url(#SVGID_13_);}\n\t.st16{fill:url(#SVGID_14_);}\n\t.st17{fill:url(#SVGID_15_);}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{fill:url(#SVGID_18_);}\n\t.st21{fill:url(#SVGID_19_);}\n\t.st22{fill:url(#SVGID_20_);}\n\t.st23{fill:none;stroke:#E94B3D;stroke-width:2.1943;stroke-miterlimit:10;}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:url(#SVGID_22_);}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{fill:url(#SVGID_28_);}\n\t.st32{fill:url(#SVGID_29_);}\n\t.st33{fill:url(#SVGID_30_);}\n\t.st34{fill:url(#SVGID_31_);}\n\t.st35{fill:url(#SVGID_32_);}\n\t.st36{fill:none;stroke:url(#SVGID_33_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st37{fill:none;stroke:url(#SVGID_34_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st38{fill:none;stroke:url(#SVGID_35_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st39{fill:none;stroke:url(#SVGID_36_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st40{fill:none;stroke:url(#SVGID_37_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st41{fill:none;stroke:url(#SVGID_38_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st42{fill:none;stroke:url(#SVGID_39_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st43{fill:none;stroke:url(#SVGID_40_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st44{fill:none;stroke:url(#SVGID_41_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st45{fill:none;stroke:url(#SVGID_42_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st46{fill:none;stroke:url(#SVGID_43_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st47{fill:url(#SVGID_44_);}\n\t.st48{fill:url(#SVGID_45_);}\n\t.st49{fill:url(#SVGID_46_);}\n\t.st50{fill:none;stroke:url(#SVGID_47_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st51{fill:none;stroke:url(#SVGID_48_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st52{fill:none;stroke:url(#SVGID_49_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st53{fill:url(#SVGID_50_);}\n\t.st54{fill:url(#SVGID_51_);}\n\t.st55{fill:url(#SVGID_52_);}\n\t.st56{fill:url(#SVGID_53_);}\n\t.st57{fill:url(#SVGID_54_);}\n\t.st58{fill:url(#SVGID_55_);}\n\t.st59{fill:url(#SVGID_56_);}\n\t.st60{fill:url(#SVGID_57_);}\n\t.st61{fill:url(#SVGID_58_);}\n\t.st62{fill:none;stroke:url(#SVGID_59_);stroke-width:1.528;stroke-miterlimit:10;}\n\t.st63{fill:#FFFFFF;}\n\t.st64{fill:url(#SVGID_60_);}\n\t.st65{fill:url(#SVGID_61_);}\n\t.st66{fill:url(#SVGID_62_);}\n\t.st67{fill:url(#SVGID_63_);}\n\t.st68{fill:url(#SVGID_64_);}\n\t.st69{fill:url(#SVGID_65_);}\n\t.st70{fill:url(#SVGID_66_);}\n\t.st71{fill:url(#SVGID_67_);}\n\t.st72{fill:url(#SVGID_68_);}\n\t.st73{fill:url(#SVGID_69_);}\n\t.st74{fill:url(#SVGID_70_);}\n\t.st75{fill:url(#SVGID_71_);}\n\t.st76{fill:url(#SVGID_72_);}\n\t.st77{fill:url(#SVGID_73_);}\n\t.st78{fill:none;stroke:url(#SVGID_74_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st79{fill:none;stroke:url(#SVGID_75_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st80{fill:none;stroke:url(#SVGID_76_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st81{fill:none;stroke:url(#SVGID_77_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st82{fill:none;stroke:url(#SVGID_78_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st83{fill:none;stroke:url(#SVGID_79_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st84{fill:none;stroke:url(#SVGID_80_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st85{fill:none;stroke:url(#SVGID_81_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st86{fill:none;stroke:url(#SVGID_82_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st87{fill:none;stroke:url(#SVGID_83_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st88{fill:none;stroke:url(#SVGID_84_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st89{fill:url(#SVGID_85_);}\n\t.st90{fill:url(#SVGID_86_);}\n\t.st91{fill:url(#SVGID_87_);}\n\t.st92{fill:none;stroke:url(#SVGID_88_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st93{fill:none;stroke:url(#SVGID_89_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st94{fill:none;stroke:url(#SVGID_90_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st95{fill:url(#SVGID_91_);}\n\t.st96{fill:url(#SVGID_92_);}\n\t.st97{fill:url(#SVGID_93_);}\n\t.st98{fill:url(#SVGID_94_);}\n\t.st99{fill:url(#SVGID_95_);}\n\t.st100{fill:url(#SVGID_96_);}\n\t.st101{fill:url(#SVGID_97_);}\n\t.st102{fill:url(#SVGID_98_);}\n\t.st103{fill:url(#SVGID_99_);}\n\t.st104{fill:none;stroke:url(#SVGID_100_);stroke-width:2.0883;stroke-miterlimit:10;}\n\t.st105{clip-path:url(#SVGID_102_);}\n\t.st106{fill:url(#SVGID_103_);}\n\t.st107{fill:url(#SVGID_104_);}\n\t.st108{fill:url(#SVGID_105_);}\n\t.st109{fill:url(#SVGID_106_);}\n\t.st110{fill:url(#SVGID_107_);}\n\t.st111{fill:none;stroke:#E94B3D;stroke-width:2.3996;stroke-miterlimit:10;}\n\t.st112{fill:url(#SVGID_108_);}\n\t.st113{fill:url(#SVGID_109_);}\n\t.st114{fill:url(#SVGID_110_);}\n\t.st115{fill:url(#SVGID_111_);}\n\t.st116{fill:url(#SVGID_112_);}\n\t.st117{fill:url(#SVGID_113_);}\n\t.st118{fill:url(#SVGID_114_);}\n\t.st119{fill:url(#SVGID_115_);}\n\t.st120{fill:url(#SVGID_116_);}\n\t.st121{fill:url(#SVGID_117_);}\n\t.st122{fill:url(#SVGID_118_);}\n\t.st123{fill:url(#SVGID_119_);}\n\t.st124{fill:none;stroke:url(#SVGID_120_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st125{fill:none;stroke:url(#SVGID_121_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st126{fill:none;stroke:url(#SVGID_122_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st127{fill:none;stroke:url(#SVGID_123_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st128{fill:none;stroke:url(#SVGID_124_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st129{fill:none;stroke:url(#SVGID_125_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st130{fill:none;stroke:url(#SVGID_126_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st131{fill:none;stroke:url(#SVGID_127_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st132{fill:none;stroke:url(#SVGID_128_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st133{fill:none;stroke:url(#SVGID_129_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st134{fill:none;stroke:url(#SVGID_130_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st135{fill:url(#SVGID_131_);}\n\t.st136{fill:url(#SVGID_132_);}\n\t.st137{fill:url(#SVGID_133_);}\n\t.st138{fill:none;stroke:url(#SVGID_134_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st139{fill:none;stroke:url(#SVGID_135_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st140{fill:none;stroke:url(#SVGID_136_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st141{fill:url(#SVGID_137_);}\n\t.st142{fill:url(#SVGID_138_);}\n\t.st143{fill:url(#SVGID_139_);}\n\t.st144{fill:url(#SVGID_140_);}\n\t.st145{fill:url(#SVGID_141_);}\n\t.st146{fill:url(#SVGID_142_);}\n\t.st147{fill:url(#SVGID_143_);}\n\t.st148{fill:url(#SVGID_144_);}\n\t.st149{fill:url(#SVGID_145_);}\n\t.st150{fill:none;stroke:url(#SVGID_146_);stroke-width:2.0883;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.7927,
    y1: 39.6096,
    x2: 92.8508,
    y2: 55.6676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.07,37.87c-5.04,0-9.19,3.83-9.71,8.73h-7.55v2.09h7.55c0.52,4.9,4.68,8.73,9.71,8.73   c5.39,0,9.77-4.38,9.77-9.77S92.46,37.87,87.07,37.87z M87.07,55.32c-4.24,0-7.68-3.45-7.68-7.68s3.45-7.68,7.68-7.68   c4.24,0,7.68,3.45,7.68,7.68S91.3,55.32,87.07,55.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3761,
    y1: 12.2653,
    x2: 36.9482,
    y2: 30.8374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.05,19.17c0-5.39-4.38-9.77-9.77-9.77c-5.39,0-9.77,4.38-9.77,9.77s4.38,9.77,9.77,9.77    c2.37,0,4.55-0.85,6.25-2.27l4.89,4.69l1.45-1.51l-4.89-4.69C34.27,23.51,35.05,21.43,35.05,19.17z M25.28,26.85    c-4.24,0-7.68-3.45-7.68-7.68s3.45-7.68,7.68-7.68s7.68,3.45,7.68,7.68S29.52,26.85,25.28,26.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.471,
    y1: 64.7281,
    x2: 81.755,
    y2: 83.0121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.85,66.34c-2.36,0-4.53,0.84-6.22,2.24l-4.76-4.25l-1.39,1.56l4.69,4.19c-1.31,1.66-2.1,3.76-2.1,6.03    c0,5.39,4.38,9.77,9.77,9.77c5.39,0,9.77-4.38,9.77-9.77C84.62,70.72,80.24,66.34,74.85,66.34z M74.85,83.79    c-4.24,0-7.68-3.45-7.68-7.68c0-4.24,3.45-7.68,7.68-7.68c4.24,0,7.68,3.45,7.68,7.68C82.53,80.34,79.08,83.79,74.85,83.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6916,
    y1: 39.4135,
    x2: 24.1418,
    y2: 55.8637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M22.99,48.68h8.33v-2.09h-8.33c-0.52-4.9-4.68-8.73-9.71-8.73c-5.39,0-9.77,4.38-9.77,9.77    s4.38,9.77,9.77,9.77C18.31,57.41,22.47,53.58,22.99,48.68z M13.28,55.32c-4.24,0-7.68-3.45-7.68-7.68s3.45-7.68,7.68-7.68    s7.68,3.45,7.68,7.68S17.51,55.32,13.28,55.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.6527,
    y1: 66.924,
    x2: 34.464,
    y2: 80.7352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35.97,63.87l-4.69,4.54c-1.66-1.29-3.74-2.07-6-2.07c-5.39,0-9.77,4.38-9.77,9.77    c0,5.39,4.38,9.77,9.77,9.77c5.39,0,9.77-4.38,9.77-9.77c0-2.37-0.85-4.55-2.27-6.25l4.63-4.48L35.97,63.87z M25.28,83.79    c-4.24,0-7.68-3.45-7.68-7.68c0-4.24,3.45-7.68,7.68-7.68s7.68,3.45,7.68,7.68C32.96,80.34,29.52,83.79,25.28,83.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8591,
    y1: 14.3493,
    x2: 79.6708,
    y2: 28.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.02,30.49l4.39-3.99c1.72,1.51,3.97,2.44,6.44,2.44c5.39,0,9.77-4.38,9.77-9.77S80.24,9.4,74.85,9.4    c-5.39,0-9.77,4.38-9.77,9.77c0,2.17,0.72,4.17,1.92,5.79l-4.38,3.98L64.02,30.49z M74.85,11.49c4.24,0,7.68,3.45,7.68,7.68    s-3.45,7.68-7.68,7.68c-4.24,0-7.68-3.45-7.68-7.68S70.61,11.49,74.85,11.49z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.6612,
    y1: 43.1074,
    x2: 67.278,
    y2: 43.1074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_7_)",
      strokeWidth: 2.0883,
      strokeMiterlimit: 10
    },
    d: "M50.45,44.4   c4.79-0.18,8.61-4.1,8.61-8.93c0-4.94-4.01-8.95-8.95-8.95s-8.95,4.01-8.95,8.95s4.01,8.95,8.95,8.95   C35.57,43.22,32.89,59.7,32.89,59.7h33.23C64.6,44.64,52.61,44.33,50.45,44.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnicanalidad);
export default __webpack_public_path__ + "static/media/omnicanalidad.f0e750e06c2c5d745f96b130c0ebce83.svg";
export { ForwardRef as ReactComponent };